import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {OperatorComponent} from "../operator/operator.component";
import {AuthGuard} from "../helpers/auth.guard";
import {ModulePermissionComponent} from "./ui/modulePermission.component";
import {RolesResolve} from "./providers/roles.resolve";
import {ModulesResolve} from "./providers/modules.resolve";
import {PermissionsResolve} from "./providers/permissions.resolve";
import {ModuleRolePermissionsResolve} from "./providers/moduleRolePermissions.resolve";


const routes: Routes = [
    {
        path: 'settings/security/module-permissions',
        component: ModulePermissionComponent,
        canActivate: [AuthGuard],
        data: {
            roles: ['ROLE_ADMIN']
        },
        resolve: {
            rolesData: RolesResolve,
            modulesData: ModulesResolve,
            permissionsData: PermissionsResolve,
            moduleRolePermissionsData: ModuleRolePermissionsResolve,
        }
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SecurityRoutingModule { }
